import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";
import { apiFetch } from "../../utils/api";

const UsuariosPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])
  const [error, setError] = useState("")

  const eliminarItem = (id) => {
    setIsLoading(true);
    setError("");
    try {
      apiFetch(`/api/users/${id}`,{
        method: "DELETE",
      })
      .then((data) => {
        if (data.status) {
          setDatos([])
          cargarDatos();
        } else {
          setError(data.message || "No se pudo eliminar el usuario.");
          setIsLoading(false);
        }
      });
    } catch (error) {
      console.error('Error:', error);
      setError(error.message || "No se pudo eliminar el usuario.");
      setIsLoading(false);
    }
  }

  const [datosTabla] = useState({
    titulo: "Usuarios",
    ruta: "/usuario",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable
  })

  const [cabecera] = useState([
    { title: "ID", key: "id" },
    { title: "NOMBRE", key: "nombre" },
    { title: "APELLIDO", key: "apellido" },
    { title: "CORREO", key: "email" },
    { title: "TELEFONO", key: "telefono" },
    { title: "ULTIMA ACTUALIZACION", key: "updatedAt", isDate: true },
  ]);

  const cargarDatos = async () => {
    setIsLoading(true);
    setError("");
    try {
      const data = await apiFetch("/api/users", { method: "GET" });
      console.log(data);
      if(data.status){
        setDatos(Array.isArray(data.data) ? data.data : []);
      } else {
        setDatos([]);
        setError(data.message || "No se pudieron cargar los usuarios.");
      }
    } catch (error) {
      console.error('Error:', error);
      setDatos([]);
      setError(error.message || "No se pudieron cargar los usuarios.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
      { isLoading ? <Loader /> : (
        <>
          { error && (
            <div className="alert alert-warning" role="alert">
              {error}
            </div>
          )}
          <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/>
        </>
      )}
      </MasterLayout>
    </>
  );
};

export default UsuariosPage;
